import { css } from "@emotion/react";

export const centered = css`
  text-align: center;
`;

export const backButtonWrapper = css`
  text-align: left;
  width: 100%;
`;
